import { render, staticRenderFns } from "./FactNumber.vue?vue&type=template&id=3cb4eefd&scoped=true&"
import script from "./FactNumber.vue?vue&type=script&lang=ts&"
export * from "./FactNumber.vue?vue&type=script&lang=ts&"
import style0 from "./FactNumber.vue?vue&type=style&index=0&id=3cb4eefd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4eefd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
